import CCBuyNow from './credit-card-buy-now';

export default CCBuyNow;
